
<div class="row p-2 " style="display: flex;justify-content: space-between;">
  <div *ngIf="showName" class="col-md-7 mat-body-1 displayFlex">
      <span [innerHTML]="question.safeHtmlContent" class="inputLabel-p" style="text-align: justify;"></span>
      <span style="margin-left: 8px;" *ngIf="question.questionToolTip">
      <img class="dupIcon-padd iconzoom cursor"
           matTooltip="{{question.questionToolTip}}"
           src="/assets/icons/information_tooltip.svg"
           alt="info icon"
           matTooltipClass="my-custom-tooltip"
           matTooltipPosition="above"/>
      </span>
  </div>
  <div class="mat-body-1" [ngClass]="{'col-md-4': showName}"> 
    <div class="row d-flex " style="justify-content: space-between;">
      <div [ngClass]="{'col-3': showName ,'col-12' :!showName}" style="margin-left: 3%;">
        <button [ngClass]="{'pt-none':IsReadOnly}" class="btn-style" (click)="openBrowseWindow(questionIndex)">Upload File</button>
        <input type="file" class="d-none" id="uploadfile{{questionIndex}}" name="uploadFile" (change)="onFileChange($event.target.files,questionIndex)" [ariaLabel]="question.questionText" [multiple]="isMultiFileSelection">
        <em *ngIf="queFilesUpload.files.length == 0" style="font-size: 11px; margin-top: -20px;text-wrap-mode: nowrap;">No File Uploaded</em>
      </div>
      <!-- <div [ngClass]="{'col-3': showName ,'col-12' :!showName}"> -->
        <!--Need to replace with svg icon-->
      <!-- <mat-icon *ngIf="queFilesUpload.files.length>1 && IsReadOnly" class="cursor lightBlue" style="font-size: 30px;"
         (click)="downloadAll()">download_all</mat-icon>   -->
       <!-- <button *ngIf="queFilesUpload.files.length>1 && IsReadOnly" class="btn-style" (click)="downloadAll()">&nbsp;Download All</button> -->
      <!-- </div> -->

    </div>

    <div *ngIf="queFilesUpload.files.length > 0" class="row p-2 m-3">
      <div *ngIf="queFilesUpload.files.length > 0">
        <div *ngFor="let files of queFilesUpload.files;let z=index;">
          <div class="row">
            <!-- Secured files show name only; no download allowed -->
            <ng-container *ngIf="question.questionFileConfig?.isSecuredFile; else downloadLink">
              <span title="{{files.name ?? files.file?.name}}">{{ files.name ?? files.file?.name }}</span>
            </ng-container>
            <ng-template #downloadLink>
              <a title="{{files.name ?? files.file?.name}}" class="lightBlue" style="text-decoration:underline;cursor:pointer;"
                 (click)="downloadFile(files,z)">{{ files.name ?? files.file?.name }}</a>
            </ng-template>
            <div *ngIf="files.isLoading" class="spinner-border spinner-border-sm text-primary" role="status" style="margin-left: 8px; vertical-align: middle;">
            </div>
            <img *ngIf="!IsReadOnly && !files.isLoading" src="/assets/icons/Delete1.svg" class="deleteBtn"
                   matTooltip="Delete" (click)="deleteFile(z)" alt="Delete icon">                   
                  </div>  
        </div>
      </div>    
    </div>
    
    <div *ngIf="(errorMessages && errorMessages.length > 0)" class="row">
      <div class="py-2" *ngFor="let error of errorMessages" style="margin-left: 3%;">
          <div class="errormsg">
             {{error}}
          </div>
        </div>
    </div>

  </div>
</div>
<!-- <div *ngIf="(errorMessages && errorMessages.length > 0)" class="row offset-6">
  <div  class="py-2" *ngFor="let error of errorMessages">
    <div class="errormsg margin-top">
      {{error}}
    </div>
  </div>
</div> -->
